import { Dropdown, IDropdownOption } from "@nuorder/components";
import { FOLDERS } from "constants/integration/folders";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { formatMessage } from "lib/globalize-util";
import * as React from "react";
import { ActionsTypes, useAssortmentDialogContext } from "./context";

export type MerchantDropdownOptions = {
    id: string;
    name: string;
    values: IDropdownOption[];
};

export const parseMerchantDimensionsIntoDropdownOptions = (
    merchantDimensions: IAllocationDimension[]
): MerchantDropdownOptions[] =>
    merchantDimensions.map((merchantAllocationDimension) => {
        const activeAllocationDimensionValues = merchantAllocationDimension.dimension_values?.map((dimensionValue) => ({
            text: dimensionValue.name,
            key: dimensionValue.id,
            id: dimensionValue.id,
        }));
        return {
            id: merchantAllocationDimension.id,
            name: merchantAllocationDimension.name,
            values: activeAllocationDimensionValues,
        };
    });

export const DimensionsDropdowns = ({
    merchantDimensionsOptions,
}: {
    merchantDimensionsOptions: MerchantDropdownOptions[];
}) => {
    const { formValues, dispatch } = useAssortmentDialogContext();
    const { dimensionsValues } = formValues;
    const handleChangeAllocationDimensionValue = (dimensionId: string) => (selectedKeys: string[]) => {
        dispatch({
            type: ActionsTypes.UPDATE_SELECTED_DIMENSIONS_VALUES,
            payload: { id: dimensionId, values: selectedKeys },
        });
    };

    return (
        <>
            {merchantDimensionsOptions.map(({ id, name, values }) => (
                <Dropdown
                    key={id}
                    label={name}
                    options={values}
                    defaultSelectedKeys={dimensionsValues?.[id] ?? []}
                    selectedKey={dimensionsValues?.[id] ?? []}
                    testId={FOLDERS.MULTI_SELECT.DROPDOWN}
                    onChange={handleChangeAllocationDimensionValue(id)}
                    multiSelect
                    isSearchable
                    placeHolder={formatMessage("Please select")}
                    selectAllText={formatMessage("Select All")}
                    searchBoxPlaceholder={formatMessage("Search")}
                    noResultsText={formatMessage("No results found")}
                />
            ))}
        </>
    );
};
